import { AsyncLabel } from "@akin2unde/flowui-react";
export default function EntityLabel({entity, code, fallback}: {entity: string; code?: string | null; fallback?: string}) {
  return <AsyncLabel lookup={entity} code={code} fallback={fallback ?? code ?? "—"} loadingText="Resolving…" showLoader />;
}
